<template>
  <div class="uk-filters">
    <Titles :title="title" />
    <Filters v-if="isFilter" ref="filterBox" :date-list="dayOfWeek" :time-list="timePeriod" :level-list="levelDegree"
             :grade-list="gradeItem" :filter-list="filterItem" @change="filterChange"
    />
    <div v-if="showCard" class="filter-card-box">
      <ClassCard
        v-for="classItem in cardList"
        :id="'goodsCard'+classItem.id"
        :key="classItem.id"
        card-class="short-card"
        :card-data="classItem"
        showl-level-degree
        :show-lesson-num="false"
        :show-original-price="true"
        :show-taxation-desc="true"
        :group-buy="classItem.activityItem"
        :show-price-is-include="classItem.showPriceIsInclude === 1"
        :show-card-bottom-left="false"
        :total-lessons="classItem.spec.lessonCount"
        :left-lessons="classItem.spec.leftLesson"
        :show-right-top-tag="!classItem.spec.courseClosed"
        :tag-type="getClassHotTagType(classItem.store, classItem.sellStore, classItem.remainSellTime)"
        :show-back-stamp="true"
        :level-degree="classItem.spec.levelDegree"
        :show-per-lesson="classItem.perShowPrice !== undefined"
        @card-click="cardClick(classItem)"
        @group-buy-click="groupClick(classItem)"
      >
        <!-- 购买、满课、待售按钮 -->
        <div v-if="!classItem.activityItem" slot="card-bottom-right">
          <div class="card-bottom">
            <!-- 库存大于0且时间小于等于1000，可点击购买 -->
            <div v-if="remainStore(classItem.store,classItem.sellStore) > 0 && classItem.remainSellTime <= 1000" class="sign-up" @click.stop="signUp({way: 'NORMAL',data:classItem})">
              {{ enrolBtnText }}
            </div>
            <!-- 库存等于0 -->
            <template v-else-if="remainStore(classItem.store,classItem.sellStore) === 0">
              <!-- <div v-if="classItem.followStatus===1||classItem.followStatus===2||!isLogin" class="sign-up " @click="followHandler(classItem.followStatus,classItem.id,classItem)">
                {{ lineUpStatus(classItem.followStatus) }}
              </div> -->
              <div class="sign-up disabled">
                {{ $t("coursesDetail.btnStatus.full") }}
              </div>
            </template>
            <!-- 出售时间大于1000，待售 -->
            <div v-else-if="classItem.remainSellTime > 1000" class="sign-up disabled">
              {{ $t("coursesDetail.btnStatus.forSale") }}
            </div>
          </div>
        </div>
      </ClassCard>
    </div>
    <div v-else class="noData">
      There are no courses for the time being
    </div>
    <SwitchStudentDialog ref="coursesDetailSwitchStudentDialog" @switch-success="switchSuccessHandler" />
    <EvaluationDialog :evaluation-dialog-info="evaluationDialogInfo" :show.sync="showEvaluationDialog" :detail-data="orderData" />
    <ConfirmDialog :show.sync="confirmDialogConfig.show" :title="confirmDialogConfig.title" :content="confirmDialogConfig.content"
                   :sub-btn-text="confirmDialogConfig.subBtnText" :main-btn-text="confirmDialogConfig.mainBtnText"
                   @subBtnClick="confirmDialogConfig.subBtnClick" @mainBtnClick="confirmDialogConfig.mainBtnClick"
    >
      <template v-if="signUpStatus == 1 || signUpStatus == 2" v-slot:content-bottom>
        <div class="evaluation-redeem-code-entrance">
          <p class="desc-text font-medium" @click="openEvaluationRedeemDialog">
            {{ $t('coursesDetail.redeemCodeEntrance[0]') }} <span class="btn-text hover-transition">{{ $t('coursesDetail.redeemCodeEntrance[1]') }}</span>
          </p>
        </div>
      </template>
    </ConfirmDialog>
    <RedeemDialog ref="evaluationRedeemDialog" origin="registration" @main-click="redeemMainClickHandler" />
    <ConfirmDialog :append-to-body="true" :show.sync="followDialog" :title="followDialogText.title" :content="followDialogText.content" :main-btn-text="followDialogText.mainBtn" :show-sub-btn="true" :sub-btn-text="followDialogText.subBtn" :show-close="false" @mainBtnClick="confirmHandler" @subBtnClick="handleCancel" />
  </div>
</template>
<script>
import Titles from '../UkCourseTitle'
import Filters from './filters.vue'
import ClassCard from 'components/courses/ClassCard'
import coursesCommon from 'mixins/courses/common.js'
import follow from 'mixins/courses/detail/follow.js'
import bus from 'common/bus'
import { oneApi } from 'config/api'
import SwitchStudentDialog from 'components/courses/SwitchStudentDialog'
import EvaluationDialog from 'components/courses/EvaluationDialog'
import ConfirmDialog from 'components/common/ConfirmDialog/index.vue';
import evaluation from 'common/evaluation.js'
import RedeemDialog from 'components/test/RedeemDialog';
import { isInView } from 'common/utils';
import { withSchoolPathPrefix } from 'common/schoolPrefix';

export default {
  components: {
    Titles, Filters, ClassCard, SwitchStudentDialog, EvaluationDialog, ConfirmDialog, RedeemDialog,
  },
  mixins: [coursesCommon, follow],
  props: {
    title: {
      type: String,
      default: 'Filter Groups',
    },
    dateList: {
      type: Array,
      default: () => [],
    },
    timeList: {
      type: Array,
      default: () => [],
    },
    levelList: {
      type: Array,
      default: () => [],
    },
    goodsList: {
      type: Array,
      default: () => [],
    },
    gradesList: {
      type: Array,
      default: () => [],
    },
    filtersList: {
      type: Array,
      default: () => [],
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      studentInfo: null,
      gradeName: this.$route.query.name,
      enrolBtnText: this.$t('coursesDetail.btnStatus.enrol'),
      groupBtnText: 'Group Buy',
      showCard: true,
      dayOfWeek: [],
      timePeriod: [],
      levelDegree: [],
      gradeItem: [],
      filterItem: [],
      isBuying: false,
      orderData: {},
      isNeedRefresh: false,
      // 诊断弹窗信息
      evaluationDialogInfo: {
        title: '',
        message: '',
        confirmButtonText: '',
        showCancel: true,
        res: {},
      },
      showEvaluationDialog: false,
      signUpStatus: 0,
      confirmDialogConfig: {
        show: false,
        title: '',
        content: '',
        mainBtnText: '',
        mainBtnClick: () => {},
        subBtnText: '',
        subBtnClick: () => {},
      },
      cardList: [],
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
  },
  watch: {
    dateList: {
      handler(val) {
        this.dayOfWeek = val
      },
      immediate: true,
      deep: true,
    },
    timeList: {
      handler(val) {
        this.timePeriod = val
      },
      immediate: true,
      deep: true,
    },
    levelList: {
      handler(val) {
        this.levelDegree = val
      },
      immediate: true,
      deep: true,
    },
    goodsList: {
      handler(val) {
        this.showCard = (val.length > 0)
        this.cardList = val;
      },
      immediate: true,
      deep: true,
    },
    gradesList: {
      handler(val) {
        this.gradeItem = val
      },
      immediate: true,
      deep: true,
    },
    filtersList: {
      handler(val) {
        this.filterItem = val
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    bus.$on('courses.detail.registrationCourses', (isNeesSwitchStudent = false) => {
      if (isNeesSwitchStudent) this.registrationCheckUser()
      else this.registrationCourse();
    });
  },
  beforeDestroy() {
    bus.$off('courses.detail.registrationCourses')
  },
  methods: {
    sensorParamBuild(data) {
      const param = {
        grade_name: this.gradeName,
        subject: data.spec.subject,
        class_id: data.spec.clazzId,
        year: data.spec.year,
        semester: data.spec.term,
        course_level: data.spec.levelDegree,
        course_category: data.spec.courseType,
        course_type: data.spec.platformType,
        content_teacher_id: data.spec.teacherIds.join(','),
        local_teacher_id: data.spec.tutorIds.join(','),
      }
      return param
    },
    groupClick(classItem) {
      this.Sensors.track('grade_page_class_button_click', {
        ...this.sensorParamBuild(classItem),
        button_name: this.groupBtnText,
        active_type: '拼团',
      })
      this.$router.push(withSchoolPathPrefix(this.$store, `/courses/detail/${classItem.id}`))
    },
    cardClick(classItem) {
      const activetype = classItem.activityItem ? '拼团' : 'null'
      this.Sensors.track('grade_page_class_click', {
        ...this.sensorParamBuild(classItem),
        active_type: activetype,
      })
    },
    signUp(orderInfo) {
      if (this.remainStore(orderInfo.data.store, orderInfo.data.sellStore) === 0) {
        this.$ElMessage({
          type: 'waring',
          message: 'is Full',
        })
        return
      }
      this.Sensors.track('grade_page_class_button_click', {
        ...this.sensorParamBuild(orderInfo.data),
        button_name: this.enrolBtnText,
        active_type: 'null',
      })
      // 报名
      this.registrationHandler(orderInfo)
    },
    // 剩余库存
    remainStore(store, soldStore) {
      const remainStore = Number(store) - Number(soldStore)
      return remainStore > 0 ? remainStore : 0
    },
    pageScrollHandler() {
      this.cardList.forEach((item) => {
        /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["item"] }] */
        if (isInView(`goodsCard${item.id}`)) {
          if (!item.show) {
            item.show = true // 已经显示过了就不要再重复埋点
            const activetype = Object.keys(item.activityItem || {}).length > 0 ? '拼团' : 'null'
            this.Sensors.track('grade_page_class_pv', {
              grade_name: this.$route.query.name,
              subject: item.spec.subject,
              class_id: item.spec.clazzId,
              year: item.spec.year,
              semester: item.spec.term,
              course_level: item.spec.levelDegree,
              course_category: item.spec.courseType,
              course_type: item.spec.platformType,
              content_teacher_id: item.spec.teacherIds.join(','),
              local_teacher_id: item.spec.tutorIds.join(','),
              active_type: activetype,
            })
            if (item.followStatus === 1 || item.followStatus === 2) {
              this.remindButtonShow(item)
            }
          }
        } else {
          // 如果不在屏幕内则改成false
          item.show = false
        }
      })
    },
    // 兑换成功后按钮点击事件处理
    redeemMainClickHandler(redeemResult) {
      if (!redeemResult.isRedeem) {
        // 继续报名
        this.registrationCourse()
      } else {
        const code = redeemResult.redeemCode || ''
        this.$router.push(`/test/recommended-classes/${code}`)
      }
    },
    filterChange(obj) {
      this.$emit('change', obj)
    },
    reset() {
      this.$refs.filterBox.reset()
    },
    /**
     * 报名
     */
    registrationHandler(orderInfo) {
      this.isBuying = true;
      this.orderData = orderInfo.data
      const skuId = this.orderData.id
      const orderCreateData = {
        way: this.orderData.way,
        skuId,
      }
      // 更新下单途径
      this.$store.dispatch('order/updateCreateOrderInfo', orderCreateData);

      this.registrationCheckUser();
    },
    registrationCheckUser() {
      this.isBuying = true
      // 判断是否登录状态
      const { isLogin } = this.$store.state.ucenter;
      if (!isLogin) {
        bus.$emit('login', { triggerSrc: 'REGISTRATION_COURSE' });
        this.isBuying = false
        return
      }

      // 选择学员
      this.registrationCourse()
      // this.openSwitchStudentDialog()
    },
    openSwitchStudentDialog() {
      this.$refs.coursesDetailSwitchStudentDialog.openDialog();
    },
    // 切换学员成功处理
    switchSuccessHandler(isSwitch, studentInfo) {
      this.isNeedRefresh = isSwitch
      this.studentInfo = studentInfo
      this.registrationCourse()
    },
    // 诊断兑换码入口点击事件
    openEvaluationRedeemDialog() {
      // 关闭当前弹窗
      this.setConfirmDialog({ show: false })
      this.$refs.evaluationRedeemDialog.openDialog()
    },
    /** 报名校验 */
    async registrationCourse() {
      this.isBuying = true;
      // 需要校验用户基础信息
      const status = await this.checkStuBase()
      // 诊断校验未通过，无法报名
      if (!status) {
        this.isBuying = false;
        return
      }
      // 去生成订单
      this.createOrder()
    },
    async checkStuBase() {
      const data = { skuId: this.orderData.id }
      const res = await this.$axios.post(oneApi.querySignUpCheckBase, data, { rewritePostBody: true, uid: this.studentId })
      if (res.code !== 0) {
        this.$ElMessage.error(res.msg)
        return false
      }

      const resData = res.data || {}
      if (resData.continue) return true

      const helper = resData.helper || {}
      this.setSignUpCheckInfoDialog(helper)

      return false
    },
    async createOrder() {
      const path = this.$store.state.order.createOrderPath
      const query = Object.assign(this.$route.query, this.$store.state.order.createOrderQuery)
      if (!path) { this.isBuying = false; return }
      this.$router.push({
        path,
        query,
      });
      this.isBuying = false;
    },
    // 根据用户诊断成绩校验用户报名资格
    async checkStuEvaluation() {
      const orderSkuId = this.$store.state.order.skuId
      const data = { skuId: orderSkuId }
      const res = await this.$axios.post(oneApi.querySignUpCheck, data, { rewritePostBody: true })
      if (res.code !== 0) {
        this.$ElMessage.error(res.msg)
        return false
      }

      const resData = res.data || {}
      if (resData.continue) return true

      const helper = resData.helper || {}
      this.setSignUpCheckInfoDialog(helper)

      // continue 为false，需要根据helper做进一步处理

      return false
    },
    // 旧诊断处理逻辑
    setEvaluationDialogOld(res) {
      //  需参与诊断测试
      if (Number(res.helper.status) === 1) {
        this.evaluationDialogInfo = {
          title: 'Evaluation Required',
          message: "Think Academy will recommend the best fit class based on the student's evaluation test",
          confirmButtonText: 'Take Evaluation Now',
          showCancel: true,
          res,
        }
        this.showEvaluationDialog = true;
        return
      }
      // 有成绩但是不符合报班条件
      if (Number(res.helper.status) === 2) {
        this.evaluationDialogInfo = {
          title: "Your evaluation score doesn't satisfy this class level",
          message: 'Based on your evaluation, we recommend you for 1 class level',
          confirmButtonText: 'OK',
          showCancel: false,
          res,
        }
        this.showEvaluationDialog = true;
        return
      }
      // 需要不符合班课策略要求 - 已报名
      if (Number(res.helper.status) === 3) {
        this.evaluationDialogInfo = {
          title: 'Reminder',
          message: res.helper.statusDesc,
          confirmButtonText: 'Confirm',
          showCancel: false,
          res,
        }
        this.showEvaluationDialog = true;
      }
      //  账号缺少联系邮箱
      if (Number(res.helper.status) === 4) {
        this.checkEmailOrPhone('email')
        return
      }
      //  账号缺少联系手机号
      if (Number(res.helper.status) === 5) {
        this.checkEmailOrPhone('phone')
      }
    },
    // 报名资格校验结果
    setSignUpCheckInfoDialog(helper) {
      const status = helper.status || helper.status === 0 ? helper.status : ''
      this.signUpStatus = status
      switch (status) {
        case 1: {
          // 需要入学测，剩余作答机会>0
          const leftChance = helper.extra && helper.extra.leftChance ? helper.extra.leftChance : 0
          const examId = helper.extra && helper.extra.examId ? helper.extra.examId : ''
          const queryObj = {
            courseId: this.orderData.spec.courseId || '',
            skuId: this.orderData.id,
          }
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case1.title'),
            content: this.$t('coursesDetail.signUpCheckInfoDialog.case1.content', [leftChance, leftChance > 1 ? 's' : '']),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case1.mainBtnText'),
            mainBtnClick: () => {
              if (!examId) {
                this.$ElMessage.error('no examId')
                // if (this.isNeedRefresh) this.init()
                return
              }
              evaluation.toEvaluation(this.$store, `/evaluation/instruction/${examId}`, queryObj, 'class_register_pop_up')
              // if (this.isNeedRefresh) this.init()
            },
            subBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case604.subBtnText'),
            subBtnClick: () => {
              this.confirmDialogConfig.show = false
              // if (this.isNeedRefresh) this.init()
            },
          })
          break;
        }
        case 2: {
          // 无法报名-诊断校验未通过
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case2.unableSignUp'),
            content: helper.statusDesc || this.$t('coursesDetail.signUpCheckInfoDialog.case2.msg'),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case2.ok'),
            mainBtnClick: () => {
              this.confirmDialogConfig.show = false
              // if (this.isNeedRefresh) this.init()
            },
          })
          break
        }
        case 3: {
          // 无法报名-不符合报班资格(不符合班课策略要求)
          const msg = helper.statusDesc || ''
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case3.title'),
            content: msg,
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case3.mainBtnText'),
            mainBtnClick: () => {
              this.confirmDialogConfig.show = false
              // if (this.isNeedRefresh) this.init()
            },
            subBtnText: '',
            subBtnClick: () => {},
          })
          break;
        }
        case 4: {
          this.checkEmailOrPhone('email')
          break;
        }
        case 5: {
          this.checkEmailOrPhone('phone')
          break;
        }
        case 604: {
          // 限时购-简版提示弹窗
          this.setConfirmDialog({
            show: true,
            title: this.$t('coursesDetail.signUpCheckInfoDialog.case604.title'),
            content: this.$t('coursesDetail.signUpCheckInfoDialog.case604.content'),
            mainBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case604.mainBtnText'),
            mainBtnClick: () => {
              this.confirmDialogConfig.show = false
              // this.$router.push('/courses/list')
            },
            subBtnText: this.$t('coursesDetail.signUpCheckInfoDialog.case604.subBtnText'),
            subBtnClick: () => {
              this.confirmDialogConfig.show = false
            },
          })
          break;
        }
        default: {
          const msg = helper.statusDesc || 'system error'
          this.$ElMessage.error(msg)
          // if (this.isNeedRefresh) this.init()
          break;
        }
      }
    },
    // 设置确认弹窗
    setConfirmDialog(...args) {
      this.confirmDialogConfig = Object.assign(this.confirmDialogConfig, args[0])
    },
    checkEmailOrPhone(type) {
      // 先判断，用户是否完善个人信息，再进行绑定
      if (!this.$store.state.ucenter.isComleteInfo) {
        bus.$emit('complete-stu-info', { triggerSrc: 'REGISTRATION_COURSE', studentInfo: this.studentInfo });
        this.isBuying = false;
        return
      }
      this.$store.dispatch('bindDialog/setDialogData', {
        visible: true,
        type,
      })
    },
  },

}

</script>
<style lang="scss" scoped>
.uk-filters {
  width: 1240px;
  margin: 0 auto;
  padding-bottom: 100px;

  .filter-card-box {
    display: flex;
    flex-wrap: wrap;
    padding: 29px 20px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 12px;
  }

  .noData {
    text-align: center;
    font-size: 18px;
    margin-top: 90px;
    color: var(--txt-color-lv2);
  }
}

.card-bottom {
  .sign-up {
    width: fit-content;
    min-width: 100px;
    padding: 0 12px;
    height: 32px;
    background: var(--txt-color-link);
    border-radius: 28px;
    text-align: center;
    color: #fff;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
  }

  .disabled {
    cursor: not-allowed;
    background: #f4f6fa;
    color: var(--txt-color-lv2);
  }
}

.short-card {
  width: 370px !important;
  margin: 15px;
}
</style>
